// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__URhSd","content":"TermsOfServicePage_content__2mH_4"};